<template>
  <div class="quick-lend">
    <div v-if="!isInBasket" class="grid-x">
      <div class="cell auto">
        <vb-form-select v-model="model.amount" v-bind="selectProps">
          <option :value="remaining">{{ $t('quickLend.entireRemaining') }}</option>
        </vb-form-select>
      </div>
      <div class="cell shrink">
        <StatefulButton class="small no-chevron"
                        :in-progress="requestPending"
                        @click.native.prevent="addItem">
          {{ $t('quickLend.submit') }}
          <FontAwesomeIcon :icon="['fac', 'shopping-cart']" />
        </StatefulButton>
      </div>
    </div>
    <div v-else>
      <ul class="list-added">
        <li>
          <font-awesome-icon icon="check-circle" class="icon-added" />
          <strong>{{ $t('quickLend.added', { amount: formattedAmount }) }}</strong>
        </li>
        <li>
          <vb-link :to="basketRoute" v-html="$t('quickLend.checkout')" />
        </li>
        <li>
          <spinner v-if="requestPending" :mono="true" :inverted="true" size="sm" class="removing-spinner" />
          <vb-link v-else @click.prevent="removeItem" v-html="$t('quickLend.undo')" />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
  import BasketTracker from '~/libs/tracking/analytics/trackers/basket'
  import HasMicroloanForm from '~/modules/loans/mixins/has-microloan-form'
  import i18n from './locales'
  import Microloan from '~/modules/loans/entities/frontend/microloan'
  import partial from 'lodash/partial'

  export default {
    name: 'QuickLend',
    i18n,
    mixins: [
      HasMicroloanForm,
    ],
    data: function () {
        return {
          action: '',
          oldBasket: null,
          list: 'Quick lend',
        }
    },
    methods: {
      addItem () {
        this.oldBasket = this.$store.getters['basket/basket']
        const xhr = this.$store.dispatch.bind(this, 'basket/add', {
          amount: this.model.amount,
          id: this.model.loanId,
          type: 'microloan',
        })

        this.action = 'add'
        this.callApi(xhr, this.onSuccess)
      },
      removeItem () {
        this.oldBasket = this.$store.getters['basket/basket']
        const xhr = partial(this.$store.dispatch, 'basket/remove', {
          id: this.model.loanId,
          type: 'microloan',
        })

        this.action = 'remove'
        this.callApi(xhr, this.onSuccess)
      },
      onSuccess (basket) {
        const microloan = new Microloan({
          'amount': this.model.amount,
          'loanId': this.model.loanId,
          'entrepreneurDisplayName': this.entrepreneurDisplayName,
        })

        const tracker = new BasketTracker()
        this.action === 'add'
          ? tracker.addToCart(microloan, this.oldBasket, this.list)
          : tracker.removeFromCart(microloan, this.list)
        tracker.addToCart(basket.donation, this.oldBasket)
      },
    },
    created () {
      this.$fa.add(
        require('@fortawesome/free-solid-svg-icons/faCheckCircle').faCheckCircle,
        require('~/assets/font-awesome-custom/fac-shopping-cart').facShoppingCart,
      )
    },
  }
</script>

<style lang="scss" scoped>
  // Unit utilities *MUST* be loaded before breakpoint utilities
  @import "~foundation-sites/scss/util/_unit";
  @import "~foundation-sites/scss/util/value";
  @import "~foundation-sites/scss/util/_breakpoint";
  @import "~assets/scss/frontend/_colours";

  .quick-lend {
    .cell {
      display: flex;
      align-items: center;

      select {
        font-size: rem-calc(14);
        margin: {
          bottom: 0;
          top: 0;
        }
        height: auto;
        padding: {
          bottom: rem-calc(10);
          top: rem-calc(10);
          left: 0.5rem;
        }
      }

      .button {
        margin: {
          bottom: 0;
          left: 0.5rem;
        }

        @include breakpoint(medium) {
          margin-left: 1rem;
        }

        svg {
          font-size: rem-calc(14);
          margin-left: 0.825rem;
        }
      }
    }

    .list-added {
      list-style-type: none;
      margin: 0;

      .icon-added {
        color: $colour-orange;
        margin-right: rem-calc(3);
      }

      .removing-spinner {
        align-self: flex-start;
        display: inline-flex;
      }
    }
  }
</style>
